<template>
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="51" height="51" rx="10" fill="#F1F8FF" />
    <mask
      id="mask0_6602_26111"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="5"
      y="6"
      width="40"
      height="39"
    >
      <rect x="5.5" y="6" width="38.8995" height="38.8995" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_6602_26111)">
      <path
        d="M36.62 25.4489V34.5775C36.62 36.4631 36.62 37.4059 36.0342 37.9917C35.4484 38.5775 34.5056 38.5775 32.62 38.5775H16.9271C16.3261 38.5775 16.0257 38.5775 15.7747 38.5346C14.5203 38.3201 13.5377 37.3375 13.3232 36.0831C13.2803 35.8321 13.2803 35.5316 13.2803 34.9307V34.9307C13.2803 34.3297 13.2803 34.0292 13.3232 33.7782C13.5377 32.5238 14.5203 31.5412 15.7747 31.3267C16.0257 31.2838 16.3261 31.2838 16.9271 31.2838H32.62C34.5056 31.2838 35.4484 31.2838 36.0342 30.698C36.62 30.1123 36.62 29.1694 36.62 27.2838V16.3203C36.62 14.4347 36.62 13.4919 36.0342 12.9061C35.4484 12.3203 34.5056 12.3203 32.62 12.3203H17.2803C15.3947 12.3203 14.4518 12.3203 13.8661 12.9061C13.2803 13.4919 13.2803 14.4347 13.2803 16.3203V34.9307"
        stroke="url(#paint0_linear_6602_26111)"
        stroke-width="2.5"
      />
      <path
        d="M20.5742 19.6133L29.3266 19.6133"
        stroke="url(#paint1_linear_6602_26111)"
        stroke-width="2.5"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_6602_26111"
        x1="23.3057"
        y1="4.92056"
        x2="43.7274"
        y2="9.4587"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6602_26111"
        x1="24.3338"
        y1="19.3315"
        x2="25.7223"
        y2="22.3696"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
